export enum GenAIExternalPlatform {
  GenAIPlatform = 'primary-chat-application',
  ManagementApp = 'management-application',
  Sentiment = 'sentiment-application',
}

export enum ChatApplication {
  BrandInsights = 'brand-insights-application',
  DigitalTwins = 'digital-twins-application',
}

export enum ChatContextIdentifier {
  BrandInsightsBrand = 'bi-brand',
  BrandInsightsFolder = 'bi-folder',
  BrandInsightsGlobal = 'bi-global',
  BrandInsightsProject = 'bi-project',
  BrandInsightsTranscript = 'bi-transcript',
  BrandInsightsDocument = 'bi-document',
}